import {
  CampaignDetailsResponse, CampaignReminderRequest,
} from '../../api-models';
import { CampaignInformation } from '../../types/campaigns.type';
import { Channel, HTTPMethod } from '../../types/enums';
import { SelectedFilters } from '../../types/filters.type';
import { AdapterInterface } from '../../types/global';
import { getCampaign } from '../../utils/campaign';

import BaseAdapter from './baseAdapter';

export default class PostAddReminderCampaign extends BaseAdapter<CampaignDetailsResponse[]> implements AdapterInterface {
  rawResponse: CampaignDetailsResponse[];

  modifiedRequest: CampaignReminderRequest;

  async adaptResponse(request: { id: string, selectedFilters: SelectedFilters }): Promise<CampaignInformation[]> {
    const formattedRequest = this.adaptRequest(request);

    await this.fetchApiResponse('/api/add-reminder-campaign', HTTPMethod.Post, formattedRequest);

    return this.rawResponse.map((campaign) => ({
      campaignCommunicationId: campaign.campaign_communication_id,
      campaignName: campaign.name,
      campaignType: campaign.benefit_name ? campaign.benefit_name : 'custom',
      communicationChannel: campaign.channel,
      snapshot: campaign.snapshot,
      status: campaign.status,
      numberOfRecipients: campaign.number_of_recipients,
      createdBy: campaign.created_by,
      reviewed: campaign.reviewed,

    }));
  }

  adaptRequest(request: { id: string, selectedFilters: SelectedFilters }): CampaignReminderRequest {
    const campaignData = getCampaign(request.id);

    this.modifiedRequest = {
      campaign_communication_id: Number(campaignData.id),
      channel: campaignData.communicationChannel === Channel.Letter ? Channel.BackendLetter : campaignData.communicationChannel.toLowerCase(),
      sms_template_id: campaignData.smsTemplateId,
      template_s3_key: campaignData.letterTemplateId,
      dispatch_date: campaignData.dispatchDate ? campaignData.dispatchDate : new Date().toISOString().split('T')[0]
      ,
    };

    return this.modifiedRequest;
  }
}
